import { ActionReducerMap } from '@ngrx/store';
import { UserPermInquiryStates } from '../states';

import * as fromUserPermInquiryReducers from './user-permissions-inquiry.reducers';

export const userPermInquiryReducers: ActionReducerMap<UserPermInquiryStates> = {
    userPermInquiry: fromUserPermInquiryReducers.userPermInquiryReducer
};